import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

//判断设备
function _isMobile() {
  const flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
  return flag
}

//路由管理
let routes = []

//PC端路由
const pc_routes = [
  {
    path: '/',
    name: 'index',
    component: () => import(/* webpackChunkName: "about" */ '../views/pc/pc_index/pc_index.vue'),
    meta: {
      isAuth: false,
      title: "首页"
    },
    children: [
      {
        path: "/",
        component: () => import("../views/pc/pc_hotspot/pc_hotspot.vue"),//贴吧
        meta: {
          isAuth: false,
          title: "贴吧"
        }
      },
      {
        path: "/pc_question",
        component: () => import("../views/pc/pc_indexView/pc_indexView.vue"),//提问
        meta: {
          isAuth: false,
          title: "提问"
        }
      },
      {
        path: "/pc_meeting",
        component: () => import("../views/pc/pc_meeting/pc_meeting.vue"),
        meta: {
          isAuth: false,
          title: "会议"
        }
      },
      {
        path: "/pc_hotlist",
        component: () => import("../views/pc/pc_hotlist/pc_hotlist.vue"),
        meta: {
          isAuth: false,
          title: "热榜"
        }
      }
    ]
  },
  {
    path: '/pc_setting',
    name: 'pc_setting',
    component: () => import('../views/pc/pc_setting/pc_setting.vue'),//设置
    children: [
      {
        path: "/pc_setting/account",
        component: () => import("../views/pc/pc_setting_accunt/pc_setting_accunt.vue"),//账户信息
        meta: {
          isAuth: true,
          title: "账户信息"
        }
      },
      {
        path: "/pc_setting/unsubscribe",
        component: () => import("../views/pc/pc_setting_unsubscribe/pc_setting_unsubscribe.vue"),//注销账号
        meta: {
          isAuth: true,
          title: "注销账号"
        }
      }
    ]
  },
  {
    path: '/pc_expert',
    name: 'pc_expert',
    component: () => import('../views/pc/pc_expert/pc_expert.vue'),//专家页
  },
  {
    path: '/pc_personal_homepage',
    name: 'pc_personal_homepage',
    component: () => import('../views/pc/pc_personal_homepage/pc_personal_homepage.vue'),//个人主页
  },
  {
    path: '/pc_quiz_details',
    name: 'pc_quiz_details',
    component: () => import('../views/pc/pc_quiz_details/pc_quiz_details.vue'),//提问详情
  },
  {
    path: '/pc_hotspot_details',
    name: 'pc_hotspot_details',
    component: () => import('../views/pc/pc_hotspot_details/pc_hotspot_details.vue'),//帖子详情
  },
  {
    path: '/pc_meeting_details',
    name: 'pc_meeting_details',
    component: () => import('../views/pc/pc_meeting_details/pc_meeting_details.vue'),//会议详情
    meta: {
      isAuth: true,
      title: "会议详情"
    }
  },
  {
    path: '/pc_message',
    name: 'pc_message',
    component: () => import('../views/pc/pc_message/pc_message.vue'),//消息页
    meta: {
      isAuth: true,
      title: "消息页"
    }
  },
  {
    path: '/pc_quizReport',
    name: 'pc_quizReport',
    component: () => import('../views/pc/pc_quizReport/pc_quizReport.vue'),//提问报道
  },
  {
    path: '/pc_authentication_data',
    name: 'pc_authentication_data',
    component: () => import('../views/pc/pc_authentication_data/pc_authentication_data.vue'),//认证/更改资料
    meta: {
      isAuth: true,
      title: "变更资料"
    }
  },
  {
    path: '/pc_search_list',
    name: 'pc_search_list',
    component: () => import('../views/pc/pc_search_list/pc_search_list.vue'),//搜索列表
  },
  {
    path: '/pc_ceshi',
    name: 'pc_ceshi',
    component: () => import('../views/pc/pc_ceshi/pc_ceshi.vue'),//认证/更改资料
  },
  {
    path: '*',
    name: 'pc_nonentity',
    component: () => import('../views/pc/pc_nonentity/pc_nonentity.vue'),//404页面
  },
  {
    path: '/pc_wx_login',
    name: 'pc_wx_login',
    component: () => import('../views/pc/pc_wx_login/pc_wx_login.vue'),//微信登录
  },
]

//移动端路由
const m_routes = [
  {
    path: '/index',
    name: 'index',
    component: () => import(/* webpackChunkName: "about" */ '../views/mobile/m_index/m_index.vue')
  }
]

if (_isMobile()) {
  // routes = m_routes  判断移动端和PC端路由
  routes = pc_routes
} else {
  routes = pc_routes
}


const router = new VueRouter({
  // mode: 'hash',
  // base: process.env.BASE_URL, // 确保基础路径正确   vue.config.js中配置publicPath = "./"

  mode: 'history',
  base: '/', // 确保基础路径正确   vue.config.js中配置publicPath = "/"
  routes
})

//路由前置守卫
router.beforeEach((to, from, next) => {
  if (to.meta.isAuth) {
    if (window.localStorage.getItem('token')) {
      next();
    } else {
      next("/")
    }
  } else {
    next();
  }
})

export default router
